import { apiClient } from './client';
import { YEREL_DEMO } from '../demo/yerelDemoKipi';

const IS_DEMO = import.meta.env.VITE_DEMO_MODE === 'true';

export interface QueryRequest {
  sourceId: number;
  parameters?: Record<string, string>;
  timeout?: number;
}

export interface QueryResponse<T = Record<string, unknown>> {
  success: boolean;
  data: T[];
  rowCount: number;
  executionTimeMs: number;
  errorMessage?: string | null;
  timedOut?: boolean;
}

/**
 * Panel'in tüm rapor sorguları bu helper'ı kullanır.
 * Demo build (VITE_DEMO_MODE=true) → /api/v2/demo/query (tenant şemasından sentetik veri okur).
 * Normal build → /api/v1/query (agent'a proxy'lenir).
 * Yerel demo (S334, `demo/yerelDemoKipi.ts`) → ağa çıkmaz, örnek veri tarayıcıda üretilir.
 */
export async function queryDataSource<T = Record<string, unknown>>(
  req: QueryRequest,
): Promise<QueryResponse<T>> {
  if (YEREL_DEMO) return (await import('../demo/yerelDemo')).yerelSorgu<T>(req);
  const url = IS_DEMO ? '/api/v2/demo/query' : '/api/v1/query';
  const { data } = await apiClient.post<QueryResponse<T>>(url, {
    sourceId: req.sourceId,
    parameters: req.parameters ?? {},
    timeout: req.timeout ?? 30,
  });
  return data;
}
